<template>
    <div class="container">
        <div class="section-header text-center">
            <h2 class="text-white"><span> Nuevos </span>Vehículos</h2>
        </div>
        <div class="row">
            <div
                class="col-md-4 col-sm-12"
                v-for="(carro, index) in carros"
                :key="index"
            >
                <div class="featured-car-list">
                    <a :href="`/ficha_tecnica/${carro._id}`">
                        <div class="featured-car-img">
                            <b-carousel
                                :id="'carousel-car-recents' + index"
                                controls
                                indicators
                                fade
                                :interval="0"
                            >
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                            carro.fotos.foto_principal
                                    "
                                    :img-alt="'Foto principal'"
                                    :class="'img-cover'"
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                            carro.fotos.foto_costado_izq
                                    "
                                    :img-alt="'Foto costado izquierdo'"
                                    :class="'img-cover'"
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                            carro.fotos.foto_diagonal
                                    "
                                    :img-alt="'Foto diagonal'"
                                    :class="'img-cover'"
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                            carro.fotos.foto_trasera
                                    "
                                    :img-alt="'Foto trasera'"
                                    :class="'img-cover'"
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                            carro.fotos.foto_diagonal_2
                                    "
                                    :img-alt="'Foto diagonal 2'"
                                    :class="'img-cover'"
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                            carro.fotos.foto_costado_der
                                    "
                                    :img-alt="'Foto costado derecho'"
                                    :class="'img-cover'"
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                            carro.fotos.foto_costado_der_2
                                    "
                                    :img-alt="'Foto costado derecho 2'"
                                    :class="'img-cover'"
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                            carro.fotos.foto_frontal
                                    "
                                    :img-alt="'Foto frontal'"
                                    :class="'img-cover'"
                                ></b-carousel-slide>
                                <b-carousel-slide
                                    :img-src="
                                        'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                            carro.fotos.foto_tablero
                                    "
                                    :img-alt="'Foto del tablero'"
                                    :class="'img-cover'"
                                ></b-carousel-slide>
                            </b-carousel>
                        </div>
                        <div class="featured-car-content">
                            <h6 class="mb-0 text-white">
                                <a
                                    :href="`/ficha_tecnica/${carro._id}`"
                                    class="text-uppercase font-weight-light"
                                    aria-label="Consultar Ficha Tecnica del  Vehiculo"
                                    >{{ carro.marca }} {{ carro.linea }}</a
                                >
                            </h6>
                            <h6
                                class="mb-0 text-uppercase text-white"
                                id="text-version"
                            >
                                <small>{{ carro.version }}</small>
                            </h6>
                            <h5
                                class="mb-0 text-white"
                                v-if="
                                    !carro.precio_feria ||
                                        carro.precio_feria == 0 ||
                                        carro.precio_feria == carro.precio
                                "
                            >
                                {{ formatNumber(carro.precio) }}
                            </h5>
                            <h5 v-else class="mb-0 text-white">
                                {{ formatNumber(carro.precio_feria) }}
                                <small class="text-danger"> Antes :</small>
                                <span class="tachado">
                                    ${{ formatNumber(carro.precio) }}</span
                                >
                            </h5>
                            <div>
                                <ul class="p-0  m-0">
                                    <li class="text-center">
                                        <b-badge variant="light">
                                            {{ carro.modelo }}</b-badge
                                        >
                                    </li>
                                    <li class="text-center">
                                        <b-badge variant="light">
                                            {{
                                                carro.kilometraje
                                                    | formatNumber
                                            }}km</b-badge
                                        >
                                    </li>
                                    <li class="text-center">
                                        <b-badge variant="light">
                                            {{
                                                get_tipo_caja(carro.caja)
                                            }}</b-badge
                                        >
                                    </li>
                                    <li class="text-center">
                                        <b-badge variant="light">
                                            {{
                                                carro.clindraje | formatNumber
                                            }}cc</b-badge
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mainHelper from "helpers/main-helper";
export default {
    props: ["carros"],
    computed: {
        carrosEnOferta() {
            return this.carros.filter(carro => {
                const feria = Number(carro.precio_feria);
                const normal = Number(carro.precio);

                return feria && feria > 0 && feria !== normal;
            });
        }
        // Solo cambiar el vfor por v-for="(carro, index) in carros" para mostrar recientes
    },
    methods: {
        returnMainImage(data) {
            if (data.fichatecnica.tipo_plan == "gratis") {
                return data.fichatecnica.inspeccion_mecanica.fotos[0];
            } else {
                return data.fichatecnica.inspeccion.fotosvideo.fotos[0];
            }
        },
        formatNumber(number) {
            return mainHelper.numberWithoutDots(number);
        },

        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Hibrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Triptonic";
                    break;
            }
        }
    }
};
</script>

<style lang="scss">
.listing-meta {
    border-bottom: 1px solid #e7e6e6;
}
.label_icon {
    font-size: 25px !important;
}
.featured-listing-wrap ul {
    padding: 0;
    margin: 0 auto 5px !important;
}
.featured-car-content {
    padding: 10px 10px 0px;
    overflow: hidden;
    background: #161616;
    margin-bottom: 30px !important;
    box-shadow: rgb(73 72 71) 0 1px 10px;
}

.featured-car-content li {
    float: left;
    font-size: 13px;
    list-style: outside none none;
    margin-bottom: 0px;
    width: 25%;
}
.featured-car-content a {
    color: #ffffff !important;
    font-size: 16px;
}

.featured-car-content ul {
    border-top: 1px solid #3a3737 !important;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    padding: 20px 0 20px 0;
}

.featured-listing-wrap h4 {
    margin: 0 auto 6px;
    font-size: 18px;
}
.badge-light {
    color: #222222;
    font-weight: 100;
    background-color: #eaeaea;
}
span.badge.badge-light {
    font-size: 15px;
    color: #ffffff;
    font-weight: 100;
    background-color: #ffffff00;
}
h6#text-version {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 16px;
}
.badge {
    padding: 0 !important;
}
span.tachado {
    text-decoration: line-through;
    font-size: 16px;
    color: #fa2837 !important;
}
.featured-car-img {
    position: relative;
    overflow: hidden;
    // height: 320px !important;
}
.featured-car-img img {
    width: 100%;
    height: 320px !important;
    object-fit: cover;
    display: block;
}
</style>
